const urldata = 'https://wyngs-my.com/api/'

export const Imageurldata = 'https://wyngs-my.com/api'

// const urldata = 'http://67.222.25.150:4000/api'

export default urldata
